import ExcelJS from "exceljs/dist/exceljs";
import logo from '../img/logo_rimac.png';
export default class Utils {
    
    static FontStyle_Titulo = {
        name: 'Roboto',
        family: 4,
        size: 15,
        bold: true,
        color: { argb: '00000000' },
      };
    static BorderStyle_Titulo = {
        top: {style:'thin', color: {argb:'00000000'}},
        left: {style:'thin', color: {argb:'00000000'}},
        bottom: {style:'thin', color: {argb:'00000000'}},
        right: {style:'thin', color: {argb:'00000000'}}
      };
    static AlignStyle_Titulo = {
        vertical: 'center', 
        horizontal: 'justify' 
      };

    static FontStyle_Cuerpo = {
        name: 'Roboto',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: '00000000' },
      };
    static BorderStyle_Cuerpo = {
        top: {style:'double', color: {argb:'00000000'}},
        left: {style:'double', color: {argb:'00000000'}},
        bottom: {style:'double', color: {argb:'00000000'}},
        right: {style:'double', color: {argb:'00000000'}}
      };
    static FontStyle_Cuerpo2 = {
        name: 'Roboto',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'FFFF0000' },
      };

    static FontStyle_TituloTable = {
        name: 'Roboto',
        family: 4,
        size: 11,
        bold: true,
        color: { argb: 'ffffffff' },
      };

    static FillStyle_HeaderTable =  {
        type: 'pattern',
        pattern:'solid',
        fgColor:{argb:'FFFF0000'}
      }
    static FontStyle_HeaderTable =  {
        color: { argb: 'FFFFFFFF' }
      }

    static async generarExcel(){
        const workbook = new ExcelJS.Workbook();
        let worksheet= workbook.addWorksheet('Instrucciones');                
        worksheet.mergeCells('A1:B3');        

        const imageId1 = workbook.addImage({
            base64: logo,
            extension: 'png',
          });
        worksheet.addImage(imageId1, 'A1:B3');   
        
        /////////////////////////////////////////////////////////
        worksheet.getColumn('B').width = 5;
        worksheet.getColumn('C').width = 20;
        worksheet.getColumn('C').font = {bold: true};
        worksheet.getColumn('D').width = 40;        
        worksheet.getColumn('E').width = 20;
        worksheet.getColumn('F').width = 90;
        /////////////////////////////////////////////////////
        worksheet.getRow(7).height = 30;
        worksheet.getRow(7).font = {bold: true};
        worksheet.getRow(8).height = 60;
        worksheet.getRow(9).height = 30;
        worksheet.getRow(10).height = 30;
        worksheet.getRow(11).height = 30;
        worksheet.getRow(12).height = 30;
        worksheet.getRow(13).height = 30;
        worksheet.getRow(14).height = 30;
        worksheet.getRow(15).height = 30;
        worksheet.getRow(16).height = 30;

        worksheet.addTable({
            name: 'MyTable',
            ref: 'B7',
            headerRow: true,
            totalsRow: false,
            style: {
              theme: 'TableStyleLight11',
              showRowStripes: false,
            },
            columns: [
              {name: 'N°', width : 8, style : {alignment : { vertical: 'justify', horizontal: 'justify' }}},
              {name: 'Campo', width : 30, style : {alignment : { vertical: 'justify', horizontal: 'justify'}}},
              {name: 'Descripción', width : 30, style : {alignment : { vertical: 'justify', horizontal: 'justify' }}},
              {name: 'Tipo de Dato', width : 30, style : {alignment : { vertical: 'justify', horizontal: 'justify' }}},
              {name: 'Restricciones', width : 300, style : {alignment : { vertical: 'justify', horizontal: 'justify' }}}
            ],
            rows: [
              [1, 'cod_operacion',`Son:
    (1) Creación
    (2) Actualización
    (3) Reseteo`, 'Numérico','Campo Obligatorio'],
              [2, 'perfil',`Puede ser EJECUTIVO, CORREDOR o ADMINISTRADOR`, 'Texto','Campo Obligatorio, deberá ser EJECUTIVO, CORREDOR o ADMINISTRADOR. De lo contrario no se creará el usuario, saldrá un error en el informe'],
              [3, 'username',`Es el código del usuario`, 'Texto','Opcional. En caso se desee crear, deberá estar vacío y en caso se desee actualizar datos o resetear contraseña, deberá completarse. Si no se encuentra en la base, debe salir un error en el informe.'],
              [4, 'nombres',`Nombres del Usuario`, 'Texto','Campo Obligatorio si se va a crear el usuario'],
              [5, 'apellidos',`Apellido Paterno del Usuario`, 'Texto','Campo Obligatorio si se va a crear el usuario'],
              [6, 'correo',`Correo del usuario`, 'Alfanumérico','Campo Obligatorio para crear, deberá tener el signo @. Para actualizar es opcional.'],
              [7, 'codigo_corredor',`Código de corredor en caso lo sea`, 'Numérico','Campo Opcional, en caso sea corredor se deberá llenar el campo'],
              [8, 'canal',`Atributo Canal Opcional`, 'Alfanumérico','Campo Opcional. Validar si el campo está en la lista de subatributos del atributo canal.'],
              [9, 'subcanal',`Atributo Subcanal Opcional`, 'Alfanumérico','Campo Opcional. Validar si el campo está en la lista de subatributos del atributo subcanal.']
            ]
          });
          worksheet.getCell('B7').font = Utils.FontStyle_HeaderTable;
          worksheet.getCell('B7').fill = Utils.FillStyle_HeaderTable;
          worksheet.getCell('C7').font = Utils.FontStyle_HeaderTable;
          worksheet.getCell('C7').fill = Utils.FillStyle_HeaderTable;
          worksheet.getCell('D7').font = Utils.FontStyle_HeaderTable;
          worksheet.getCell('D7').fill = Utils.FillStyle_HeaderTable;
          worksheet.getCell('E7').font = Utils.FontStyle_HeaderTable;
          worksheet.getCell('E7').fill = Utils.FillStyle_HeaderTable;
          worksheet.getCell('F7').font = Utils.FontStyle_HeaderTable;
          worksheet.getCell('F7').fill = Utils.FillStyle_HeaderTable;


          worksheet.mergeCells('C1:F3');       
          worksheet.getCell('C1').value = 'Instrucciones para importar operaciones masivas en la aplicación';
          worksheet.getCell('C1').font = Utils.FontStyle_Titulo;
          worksheet.getCell('C1').border = Utils.BorderStyle_Titulo;
          worksheet.getCell('C1').alignment = Utils.AlignStyle_Titulo;

          worksheet.mergeCells('A5:F5');
          worksheet.getCell('A5').value = '1. Deberás registrar los siguiente campos en la hoja "Formato":';
          worksheet.getCell('A5').font = Utils.FontStyle_Cuerpo;

          worksheet.mergeCells('B17:F17');
          worksheet.getCell('B17').value = `* Tantos atributos se creen en el módulo "Gestión de Atributo" se deberá llenar en el Formato como nuevas columnas, siguiendo las restricciones establecidas al atributo.`;          
          worksheet.getCell('B17').font = Utils.FontStyle_Cuerpo2;

          worksheet.mergeCells('A19:F19');
          worksheet.getCell('A19').value = `2. Todos los campos que se registrarán como campos obligatorios para CREACIÓN: perfil, nombres, apellidos, correo. En caso el perfil sea corredor, es obligatorio completar el codigo_corredor. Deberán estar escritos correctamente.`;          
          worksheet.getCell('A19').font = Utils.FontStyle_Cuerpo;

          worksheet.mergeCells('A21:F21');
          worksheet.getCell('A21').value = `3. Todos los campos que se registrarán como campos obligatorios para ACTUALIZACIÓN : username. Deberán estar escritos correctamente.`;
          worksheet.getCell('A21').font = Utils.FontStyle_Cuerpo;

          worksheet.mergeCells('A23:F23');
          worksheet.getCell('A23').value = `4. Todos los campos que se registrarán como campos obligatorios para RESETEO : username. Deberán estar escritos correctamente.`;
          worksheet.getCell('A23').font = Utils.FontStyle_Cuerpo;

          worksheet.mergeCells('A25:F25');
          worksheet.getCell('A25').value = `5. Finalmente deberás guardar solo la hoja "Formato" como archivo .csv delimitado por COMA (,) para importarlo en la aplicación.`;
          worksheet.getCell('A25').font = Utils.FontStyle_Cuerpo;
        
        // write to a new buffer
        const buffer = await workbook.xlsx.writeBuffer();        
        let url = window.URL.createObjectURL(new Blob([buffer]));
        let a = document.createElement('a');
        a.href = url;
        a.download = `Instrucciones.xlsx`;                                
        a.click();
    }
    
}